<div class="content-wrapper">

    <section class="content-header">
        <h1>
            Gerenciar Pendência
            <small>Criar, listar e editar</small>
        </h1>
        <ol class="breadcrumb">
            <li>
                <a routerLink="/home">
                    <i class="fa fa-home"></i> Home</a>
            </li>
            <li class="active">
                <a routerLink="/pendencia">Gerenciar Pendência</a>
            </li>
        </ol>
    </section>

    <br>

    <div class="col-md-12">
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Gerenciar conteúdo</h3>
            </div>

            <div class="box-body no-padding">

                <div class="col-xs-12">
                    <h3>Opções</h3>
                    <hr>
                    <div class="col-md-12">
                        <a class="btn btn-app" pTooltip="Listar" tooltipPosition="top" routerLink="/pendencia/listar" routerLinkActive="btn-app-active">
                            <i class="far fa-file-alt"></i> Listar
                        </a>
                        <a class="btn btn-app" pTooltip="Cadastrar " tooltipPosition="top" routerLink="/pendencia/cadastrar" routerLinkActive="btn-app-active">
                            <i class="fa fa-plus"></i>Cadastrar
                        </a>
                        
                    </div>
                </div> 

                <div class="col-md-12">
                    <hr>
                </div>

                <div class="col-md-12">
                    <router-outlet></router-outlet>
                </div>

                <div class="col-md-12">
                    <hr>
                </div>

            </div>

            <div class="box-footer clearfix"></div>

        </div>

    </div>
</div>